import { useEffect } from 'react';

/**
 * Forces light theme on public/auth pages (login, signup, forgot-password, etc.)
 * Restores the user's saved theme preference on unmount.
 */
const useForceLightTheme = () => {
  useEffect(() => {
    const previousTheme = document.documentElement.getAttribute('data-theme');
    document.documentElement.setAttribute('data-theme', 'light');

    return () => {
      // Restore previous theme on unmount
      const saved = localStorage.getItem('theme') || previousTheme || 'light';
      document.documentElement.setAttribute('data-theme', saved);
    };
  }, []);
};

export default useForceLightTheme;
